import React, { useEffect, useState } from 'react';
import { Box, makeStyles, Link as MuiLink } from '@material-ui/core';
import Link from 'next/link';

import { MIN_FREE_DELIVERY_PRICE } from 'domain/constants';

const AnnouncementBar: React.FC = (): JSX.Element => {
  const classes = useStyles();

  const [showWrapping, setShowWrapping] = useState(false);

  useEffect(() => {
    setShowWrapping(Math.random() < 0.5);
  }, []);

  if (showWrapping)
    return (
      <Box className={classes.bar}>
        🎁 Подарункове пакування для замовлень від 1000 грн та для планерів на кільцях
      </Box>
    );

  return (
    <Link href="/delivery" passHref>
      <MuiLink className={classes.bar}>
        🚚 Безкоштовна доставка від {MIN_FREE_DELIVERY_PRICE} грн
      </MuiLink>
    </Link>
  );
};

const useStyles = makeStyles((theme) => ({
  bar: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
    padding: theme.spacing(1, 2),
    backgroundColor: 'rgba(156, 219, 224, 0.3)',
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '0.8125rem',
    transition: 'background-color 200ms',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: 'rgba(156, 219, 224, 0.5)'
    }
  }
}));

export default AnnouncementBar;
